/**
 * Constants chứa các title của các module/trang trong ứng dụng
 * Sử dụng để quản lý title một cách tập trung và dễ bảo trì
 */
export const PAGE_TITLES = {
  // module
  DASHBOARD: 'Dashboard',
  CARD: 'Card',
  PROVIDER: 'Provider',
  USER: 'User',
  TRANSACTION: 'Transaction',
  ACCOUNT: 'Account',
  EVENT: 'Event',
  AUDIT: 'Audit',
  CUSTOMER: 'Customer',
  DetailCustomer: 'Customer-detail',
  VirtualAccount: 'Virtual Accounts',
  PROFILE: 'Profile',
  SETTINGS: 'Settings',
  CustomerRequest: 'Customer Request',
  CASHBACK: 'Cashback',
  STABLECOIN: 'Stablecoin Payments',

  // Settings sub-pages — values must match `label` from BE settings API
  SETTINGS_PROFILE: 'My Profile',
  SETTINGS_USERS: 'Users',
  SETTINGS_BALANCE_ALERT_RULES: 'Balance Alert Rules',
  SETTINGS_BOT: 'Bot',
  SETTINGS_TRANSACTION_RULES: 'Transaction Notification Rules',
  SETTINGS_COMPANY_PROFILE: 'Company Profile',
  SETTINGS_COMPANY_SECURITY: 'Company Security',
  SETTINGS_PERSONAL_SECURITY: 'Security',
  SETTINGSCOMPANYPROFILE: 'Company Profile',
  SETTINGSCOMPANYSECURITY: 'Company Security',

  // Authentication
  LOGIN: 'Login',
  REGISTER: 'Register',
  FORGOT_PASSWORD: 'Forgot Password',
  RESET_PASSWORD: 'Reset Password',

  // User Management
  USERS: 'User',
  USER_PROFILE: 'Thông tin cá nhân',
  USER_ROLES: 'Phân quyền người dùng',

  // Content Management
  CONTENT: 'Quản lý nội dung',
  POSTS: 'Bài viết',
  CATEGORIES: 'Danh mục',
  TAGS: 'Thẻ',

  GENERAL_SETTINGS: 'Cài đặt chung',
  SYSTEM_SETTINGS: 'Cài đặt hệ thống',

  // Reports
  REPORTS: 'Báo cáo',
  ANALYTICS: 'Phân tích',

  // Error Pages
  NOT_FOUND: 'Không tìm thấy',
  UNAUTHORIZED: 'Không có quyền truy cập',
  SERVER_ERROR: 'Lỗi máy chủ',
} as const;

// Type cho các title keys
export type PageTitleKey = keyof typeof PAGE_TITLES;
